var r = /* @__PURE__ */ ((e) => (e.Next = "next", e.Prev = "prev", e))(r || {}), v = /* @__PURE__ */ ((e) => (e.Asc = "ASC", e.Desc = "DESC", e))(v || {});
export {
  r as PaginationOrderEnum,
  v as SortDirectionEnum
};
